import React, { createContext, useContext, useState } from 'react';

const DebugContext = createContext();

export function DebugProvider({ children }) {
  const [debugMode, setDebugMode] = useState(false);
  return (
    <DebugContext.Provider value={{ debugMode, setDebugMode }}>
      {children}
    </DebugContext.Provider>
  );
}

export function useDebug() {
  return useContext(DebugContext);
}
